import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const GoogleMapApi = createApi({
  reducerPath: "googleMap",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_GOOGLE_MAPS_URL}`,
  }),
  endpoints: (builder) => {
    return {
      getMapAddress: builder.query({
        query: ({ latitude, longitude }) => {
          return {
            url: `/json?latlng=${latitude},${longitude}&language=en&region=us&key=${process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY}`,
            method: "GET",
          };
        },
      }),
    };
  },
});
export const { useGetMapAddressQuery } = GoogleMapApi;
export { GoogleMapApi };
